import { Brand } from "models/inventory/interfaces/brand.interface";
import { PandaboardApiInstance } from "../../../helpers/api";

export const getBrands = (): Promise<Brand[]> =>
  PandaboardApiInstance
    .get("brand")
    .then((response) => response.data as Brand[])
    .catch(() => [] as Brand[]);
